<button
  type="button"
  id="global-filters-score"
  class="score-button pendo-score-button"
  (click)="openScoreSetup()"
>
  <ng-container *ngIf="score$ | async as score">
    <span class="score-button__name">{{ score.name }}</span>
    <span class="score-button__short">{{ score.short }}</span>
  </ng-container>
  <mat-icon class="score-button__caret">expand_more</mat-icon>
</button>
